<div class="main-container">
    <p-confirmDialog key="deleteConfirmation" header="Delete Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    <div class="table-container">
        <p-table selectionMode="single" [value]="quotations">
            <ng-template pTemplate="header">
                <tr>
                    <th [style]="{width: '55px'}">ID</th>
                    <th>Description</th>
                    <th [style]="{width: '100px'}">Total</th>
                    <th [style]="{width: '90px'}">Currency</th>
                    <th [style]="{width: '100px'}">Created</th>
                    <th [style]="{width: '120px'}">Created By</th>
                    <th [style]="{width: '100px'}">Sent</th>
                    <th [style]="{width: '100px'}">Sent By</th>
                    <th [style]="{width: '200px'}">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-quotation>
                <tr [pSelectableRow]="quotation">
                    <td>
                        {{quotation.id}}
                    </td>
                    <td>
                        {{quotation.description}}
                    </td>
                    <td>
                        {{quotation.totalInBaseCurrency}}
                    </td>
                    <td>
                        {{quotation.baseCurrency.isoCode}}
                    </td>
                    <td>
                        {{quotation.created | date: 'dd/MM/yyyy HH:mm'}}
                    </td>
                    <td>
                        <span>
                            {{quotation.createdBy.name}}
                        </span>
                    </td>
                    <td>
                        {{quotation.lastSent | date: 'dd/MM/yyyy HH:mm'}}
                    </td>
                    <td>
                        <span *ngIf="quotation.lastSentBy">
                            {{quotation.lastSentBy.name}}
                        </span>
                    </td>
                    <td>
                        <div class="buttons-container">
                            <p-button icon="pi pi-file-pdf" pTooltip="Download PDF" tooltipPosition="top"
                                (onClick)="downloadReport(quotation)"></p-button>
                            <a routerLink="/management/contact-request-quotation-preview/{{quotation.id}}/{{contactRequestService.contactRequest!.language.name}}"
                                target="_blank">
                                <p-button icon="pi pi-search"></p-button>
                            </a>
                            <p-button icon="pi pi-envelope" pTooltip="Send by Email" tooltipPosition="top"
                                (onClick)="activateEmailDialog(quotation)"></p-button>
                            <p-button icon="pi pi-clone" pTooltip="Duplicate & Create new" tooltipPosition="top"
                                (onClick)="cloneQuotation(quotation)"></p-button>
                            <p-button icon="pi pi-trash" pTooltip="Delete this quotation" tooltipPosition="top"
                                (onClick)="deleteQuotation(quotation)" styleClass="p-button-danger"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog (onHide)="closeEmailModal()" header="Send email to: {{contactRequestService.contactRequest!.email}}"
        [(visible)]="displayMailingDialog" [modal]="true" [style]="{width: '50vw', height: '84vh'}">
        <div [formGroup]="emailForm">
            <p-dropdown placeholder="load a template" [options]="emailTemplates" optionLabel="name"
                formControlName="emailTemplate" (onChange)="insertLeadEmailTemplate($event.value)"></p-dropdown>
            <div>
                <div>
                    <p>Subject:</p>
                </div>
                <div>
                    <input formControlName="subject" pInputText class="subject-input">
                </div>
            </div>
            <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
            <div>
                <span>Siganture: </span>
                <p-dropdown placeholder="Select signature" [options]="contactRequestService.emailSignatures"
                    optionLabel="language.name" formControlName="signature"></p-dropdown>
            </div>
            <div>
                <span>
                    Paste Pixel
                </span>
                <p-checkbox [binary]="true" formControlName="withPastePixel"></p-checkbox>
            </div>
        </div>
        <div *ngIf="attachmentLoading">
            <p>Loading file...</p>
        </div>
        <div *ngIf="attachedQuotationFile">
            <a [href]="getObjectURL(attachedQuotationFile.file)"
                [download]="attachedQuotationFile.file.name">{{attachedQuotationFile.file.name}}
                ({{attachedQuotationFile.file.size / 1000}} KB)</a>
        </div>
        <div class="send-button-container">
            <div class="send-button-wrap">
                <p-button label="Send" (onClick)="sendEmailToClient()" [disabled]="attachmentLoading || emailSending">
                </p-button>
            </div>
            <div class="cancel-button-wrap">
                <p-button label="Cancel" (onClick)="closeEmailModal()" styleClass="p-button-warning"
                    [disabled]="attachmentLoading || emailSending"></p-button>
            </div>
        </div>
    </p-dialog>
</div>